module.exports = __webpack_public_path__ + "img/base_model2.959456e9.png";